
const SurveyList = () =>
  import(/* webpackChunkName: "SurveyList" */ 'src/components/Dashboard/Views/Surveys/SurveyList.vue');

const SurveyEdit = () =>
  import(/* webpackChunkName: "SurveyEdit" */ 'src/components/Dashboard/Views/Surveys/SurveyEdit.vue');
const SurveyReport = () =>
  import(/* webpackChunkName: "SurveyEdit" */ 'src/components/Dashboard/Views/Surveys/SurveyReport.vue');
export const surveyRoutes = [
  {
    path: 'surveys/add/',
    name: 'Create Survey',
    component: SurveyEdit,
    meta: { requiresAcl: 'edit_surveys' }
  },

  {
    path: 'surveys/edit/:id',
    name: 'Edit Survey',
    component: SurveyEdit,
    meta: { requiresAcl: 'edit_surveys' }
  },
  {
    path: 'surveys/list/',
    name: 'List Surveys',
    component: SurveyList,
    meta: { requiresAcl: 'view_surveys' }
  },
  {
    path: 'surveys/report/:id',
    name: 'Survey Report',
    component: SurveyReport,
    meta: { requiresAcl: 'view_survey_reports' }
  }
];
